import { type DocumentShortcutState,generateObjectId, SHORTCUT_LIST_FIELD } from '@alpod-ai-writer/shared';
import { useCallback } from 'react';

import { useDocumentEditor } from './useDocumentEditor.hook';
import { useYDocMap } from './useYDocText.hook';

export function useShortcutList() {
    const editor = useDocumentEditor();
    const { entries, docMap, addEntry } = useYDocMap<DocumentShortcutState>(editor.yjsProvider.document, SHORTCUT_LIST_FIELD);

    const addShortcut = useCallback((label: string) => {
        const id = generateObjectId();

        addEntry(id, {
            shortcut: label,
            meaning: ''
        });

        return { id };
    }, [ addEntry ]);

    return {
        shortcutList: entries,
        shortcutMap: docMap,
        addShortcut
    };
}
